import { useParams } from 'react-router-dom';
import { MEETING_LINK_PATH_KEY } from '../lib/constants';

export default function useMeetingLinkPath(): string | undefined {
  return useParams<{[ MEETING_LINK_PATH_KEY ]: string | undefined }>()[MEETING_LINK_PATH_KEY];
}
